<template>
  <div class="text-center">
    <h4>Authentication was completed successfully!</h4>
    <span>Redirecting to dashboard...</span>
  </div>
</template>

<script>
export default {
  name: 'Redirect',
  created() {
    this.loginUser();
  },
  methods: {
    async loginUser() {
      await this.$store.dispatch({
        type: 'loginWithPge',
        url: 'green_button/auth/login',
        code: this.$route.query.code,
      });
    },
  },
};
</script>

<style scoped></style>
